import React from 'react';
import t from 'prop-types';

var SeccionInferior = function SeccionInferior(_ref) {
  var children = _ref.children;
  return React.createElement('div', {
    className: 'seccionInferior'
  }, children);
};

SeccionInferior.propTypes = process.env.NODE_ENV !== "production" ? {
  children: t.any
} : {};
export default SeccionInferior;